import { Alert } from '../interfaces/alert'

export const Alerts: Alert[] = [
  {
    name: 'Allison Hall',
    nycid: 268404452,
    info: 'Social History Meeting',
    date: new Date(),
    type: 'danger',
  },
  {
    name: 'Jennifer Wu',
    nycid: 258407789,
    info: 'Placement Package',
    date: new Date(),
    type: 'warning',
  },
  {
    name: 'Alliyah Duncan',
    nycid: 238405789,
    info: 'Classroom Observation',
    date: new Date(),
    type: 'warning',
  },
]